import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import UserGroupForm from '@/components/user-groups/UserGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUserGroup',
  emits: ['created'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;

    const form = useForm({
        name: '',
        user_ids: [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.user-groups.store'),
    "query-key": [_unref(QueryKey).USER_GROUPS],
    title: "user-groups.user_groups_create",
    "success-message": "user-groups.created",
    "button-text": "user-groups.user_groups_create"
  }, {
    default: _withCtx(() => [
      _createVNode(UserGroupForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})